import React from 'react'

export default function ContactMuveszetterapiaContent() {
  return (
    <>
      <div className="space-y-6 p-6 text-lg">
        <div className="space-y-4">
          <h3 className="text-xl font-bold text-amber-800">Művészetterápia</h3>

          <div className="space-y-3">
            <div className="flex items-start gap-4 mb-12">
              <img
                src="/images/paint-palette.svg"
                alt="Festék paletta"
                className="w-16 h-16 flex-shrink-0 mt-1"
              />
              <p className="text-justify flex-1">
                Ha szeretnél többet megtudni a művészetterápiás foglalkozásokról,
                egyéni vagy csoportos alkalmakról, vagy kérdésed van, írj bátran
                az űrlapon keresztül. Örömmel válaszolok.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
